export default "__VITE_ASSET__ImFgjxDF__"